(function () {
  'use strict';

  class ProductivityIndicatorsCtrl {
    constructor(Keys, ServiceVfiltro, FactoryVfiltro, safetyService, Authenticator, blockUI, $state, moment) {
      this.keys = Keys;
      this.moment = moment;
      this.factoryVfiltro = FactoryVfiltro;
      this.serviceVfiltro = ServiceVfiltro;
      this.authenticator = Authenticator;
      this.safetyService = safetyService;
      this.blockUI = blockUI;
      this.state = $state;

      this.filtro = null;
      this.user = null;

      this.initialize();
    }

    initialize() {
      this.blockUI.start();
      return this.initFilter()
        .then(() => this.loadUser())
        .then(() => this.loadReact())
        .finally(() => {
          this.blockUI.reset();
          this.blockUI.stop();
        });
    }

    initFilter() {
      return this.serviceVfiltro.init(
        this.factoryVfiltro.get([
          {
            name: 'uoId',
            key: this.keys.uo.name
          },
          {
            key: this.keys.dateTime.name,
            time: false,
            required: true,
            dateLimit: 30,
            maxDate: this.moment().subtract(1, 'days').endOf('day').format(),
            defaultValues: {
              ultimos7dias: {
                active: true
              },
              ultimos30dias: {
                active: true
              }
            }
          },
          {
            name: 'duoRoutes',
            key: this.keys.duoRoutes.name,
            ignoreValidation: true
          }
        ])
      ).then((filtro) => {
        this.filtro = filtro;
      });
    }

    loadUser() {
      return this.authenticator.getUser()
        .then((user) => {
          this.user = user;
        });
    }

    loadReact() {
      const appName = 'safetyApp',
          componentName = './ProductivityIndicatorsPageRoute',
          componentId = 'safety-productivity-indicators',
          props = this.getReactProps();

      return this.safetyService
        .initialize()
        .then(() => this.safetyService.loadReactComponent(appName, componentName, componentId, props));
    }

    getReactProps() {
      const filteredRoutes = this.filtro.find((f) => f.key === this.keys.duoRoutes.name),
          routeUUIDs = filteredRoutes ? filteredRoutes.values.map((r) => r.id) : [],
          ouId = this.filtro.find((f) => f.key === this.keys.uo.name).value.id,
          date = this.filtro.find((f) => f.key === this.keys.dateTime.name).value,
          startDate = date.startDate,
          endDate = date.endDate;

      return {
        user: this.user,
        filter: {
          ouId: ouId,
          startDate: startDate,
          endDate: endDate,
          routeUUIDs: routeUUIDs
        }
      };
    }

  }

  angular
    .module('productivity-indicators')
    .controller('ProductivityIndicatorsCtrl', ProductivityIndicatorsCtrl);
}());
